import type { ComponentProps } from 'react'
import { Trans } from 'react-i18next/TransWithoutContext'

import { i18n } from '../locales/i18n'
import { useFunkitTranslation } from './FunkitI18nProvider'

type FunkitTransProps = Omit<ComponentProps<typeof Trans>, 'i18n' | 't'>

/**
 * The SDK's `<Trans>`: copy with tagged spans (`<terms>…</terms>`) rendered
 * through the `components` map, bound to the SDK's private i18next instance.
 *
 * The context-free `Trans` is deliberate: the host app may wrap the sheet in
 * its own react-i18next provider, and the contextual one would read that
 * provider's namespace. `t` comes from the SDK provider so the copy follows
 * the SDK locale, not the host's.
 */
export function FunkitTrans(props: FunkitTransProps) {
  const { t } = useFunkitTranslation()
  return <Trans {...props} i18n={i18n} t={t} />
}
